<template>
  <div class="rounded-lg bg-light-grey p-4">
    <div class="font-bold mb-3">{{ $t('product.usually_bought_with') }}</div>

    <device-wrapper #default="{ desktop }">
      <div v-if="desktop" class="relative mb-3">
        <swiper-wrapper #default="{item, index}" :items="products">
          <product
              :product="item" class="!min-w-[130px] !max-w-[130px]" hide-cart-btn
              hide-fav-btn hide-tags :source-data="setEventsData(item)">
            <template #badge>
              <discount-price :discount-ratio="item?.special[0]?.discount_ratio"/>
            </template>
            <template #price>
              <price :increase-font-by="2" :product="item" hide-discount-ratio/>
            </template>
            <template #image>
              <div class="relative">
                <van-checkbox :modelValue="isSelected(item.id)" :name="item.id"
                              class="absolute" @click.prevent.stop="toggleProduct(item.id)"></van-checkbox>
                <niceone-image :src="item.thumb" width="120" @click.prevent.stop="toggleProduct(item.id)"/>
              </div>
            </template>
          </product>
          <span v-if="index !== products.length - 1"
                class="absolute text-[20px] ltr:-right-4 rtl:-left-4 top-[50%] bg-light-grey">+</span>
        </swiper-wrapper>
      </div>

      <div v-else class="flex relative overflow-x-auto mb-3">
        <product v-for="(product, index) in products" :key="`product-${index}`"
                 :class="{ 'ltr:mr-5 rtl:ml-5': index !== products.length - 1 }"
                 :product="product" class="!min-w-[130px] !max-w-[130px]" hide-cart-btn
                 hide-fav-btn hide-tags :source-data="setEventsData(product)">
          <template #badge>
            <discount-price :discount-ratio="product?.special[0]?.discount_ratio"/>
          </template>
          <template #price>
            <price :increase-font-by="2" :product="product" hide-discount-ratio/>
          </template>
          <template #image>
            <div class="relative">
              <van-checkbox :modelValue="isSelected(product.id)" :name="product.id"
                            class="absolute" @click.prevent.stop="toggleProduct(product.id)"></van-checkbox>
              <niceone-image :src="product.thumb" width="120" @click.prevent.stop="toggleProduct(product.id)"/>
            </div>
          </template>
          <template #divider>
          <span v-if="index !== products.length - 1"
                class="absolute text-[20px] ltr:-right-4 rtl:-left-4 top-[50%] bg-light-grey">+</span>
          </template>
        </product>
      </div>
    </device-wrapper>

    <van-button :disabled="!productIds.length || hasOptionsNotSelected || isLoading" :loading="isLoading"
                block style="background: #997adb1f; color: #997adb;" @click="addToCart">
      {{ getButtonText }}
    </van-button>
  </div>
</template>

<script setup>
import {addMultipleCartMutation} from "@/plugins/API/cart";
import Product from "@/components/Product";
import SwiperWrapper from "@/components/common/SwiperWrapper";
import Price from "@/components/product/Price"
import DiscountPrice from "@/components/DiscountPrice";
import {EVENT_SOURCES, TRACKERS} from "@/constants/events";

const {t} = useI18n()
const productIds = ref([])
const props = defineProps({
  id: {
    type: [String, Number],
    required: true
  },
  products: {
    type: Array,
    default: () => []
  },
  product: {
    type: Array,
    default: () => []
  },
  selectedOption: {
    type: Object,
    default: null
  },
  data: {
    type: Object,
    default: {}
  }
})

onMounted(() => {
  productIds.value = props.products.map(item => item.id) || []
})

const isSelected = (productId) => {
  return productIds.value.includes(productId);
};

const toggleProduct = (productId) => {
  if (isSelected(productId)) {
    productIds.value = productIds.value.filter(id => id !== productId);
  } else {
    productIds.value.push(productId);
  }
};

const hasOptionsNotSelected = computed(() => !!props.data?.has_option && !props.selectedOption?.price)
const getButtonText = computed(() => {
  if (hasOptionsNotSelected.value) {
    return t('product.btn.pick_an_option')
  }

  return !productIds.value.length ? t('product.btn.choose_items_to_order') : t('product.btn.add_items_together', {expr: productIds.value.length + 1})
})


const {isLoading, mutateAsync} = addMultipleCartMutation();
const addToCart = () => {
  const params = props.products.filter(item => productIds.value.includes(item.id)).map(val => {
    return {
      product_id: val.id,
      quantity: 1,
      option: ''
    }
  })

  const {related_products, ...product} = props?.data
  let products = [...related_products, product]

  const option = props.selectedOption?.product_option_value_id && {
    [props.data?.options[0].product_option_id]:
    props.selectedOption?.product_option_value_id,
  };

  params.push({product_id: props.id, option, quantity: 1})

  mutateAsync({params}).then((data) => {

    track(TRACKERS.ADD_TO_CART, {
      product: products,
      items_count: products?.length,
      sourceData: {
        ...EVENT_SOURCES.ITEM_BOUGHT_WITH_SECTION,
        source_name: props?.data?.en_name,
        source_id: props?.data?.id
      },
      quick_add: true,
      is_prdouct_array: true
    })
  })

}

const setEventsData = (item) => {
  return {...EVENT_SOURCES.ITEM_BOUGHT_WITH_SECTION, source_name: item?.en_name, source_id: item?.id}
}
</script>